"use client";

import { REQUEST_CALLBACK } from "@/gql/unit-and-project";
import { useAuth } from "@/hooks/use-auth";
import { trackCallback } from "@/utils/analytics/track-callback";
import { utmUtils } from "@/utils/utm";
import { useMutation } from "@apollo/client";
import { useState } from "react";
import { toast } from "sonner";
export function useCallbackRequest() {
  const {
    isAuthenticated
  } = useAuth();
  const [callbackModalOpen, setCallbackModalOpen] = useState(false);
  const {
    user
  } = useAuth();
  const [requestCallbackMutation, {
    loading: callbackLoading
  }] = useMutation(REQUEST_CALLBACK);
  const userPhoneNumbers = user?.phones?.map(p => p.number) || [];
  const showErrorToast = (message: string, description?: string) => {
    toast.error(message, {
      description: description || "Please try again later",
      duration: 5000,
      position: "bottom-right"
    });
  };
  const handleCallbackRequest = async (phone: string, callback: () => void) => {
    try {
      const variables = {
        filters: {
          requestCallback: {
            phone,
            url: window.location.pathname,
            info: {
              utm: utmUtils.getCurrent()
            }
          }
        }
      };
      const {
        data: res
      } = await requestCallbackMutation({
        variables
      });
      const result = res?.unitMethods?.requestCallback;
      if (result) {
        // Track callback request
        trackCallback({
          phoneNumber: phone
        });
        toast.success("Callback requested successfully", {
          duration: 3000,
          position: "bottom-right"
        });
        callback();
      } else {
        showErrorToast("Callback request failed.");
      }
    } catch (_) {
      showErrorToast("Could not request callback");
    }
  };
  const openCallbackModal = () => setCallbackModalOpen(true);
  const closeCallbackModal = () => setCallbackModalOpen(false);
  return {
    isAuthenticated,
    callbackModalOpen,
    userPhoneNumbers,
    callbackLoading,
    openCallbackModal,
    closeCallbackModal,
    handleCallbackRequest
  };
}